<template>
    <MainContentSearchable
        title="Listado de boletines"
        id="boletines"
        v-model="filtersBoletines"
        :meta="loading ? {} : boletines.meta"
        :disabled="loading"
        @updated="debouncedGetBoletines"
    >
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de boletines</h3>
            <div class="card-tools mb-3">
                <router-link
                    :to="{ name: 'back.emails.boletines.crear' }"
                    class="btn btn-primary"
                    id="crear-boletin"
                >
                    Crear boletín
                </router-link>
            </div>
        </template>

        <template v-slot:content>
            <b-row>
                <b-col cols="12" md="8" lg="10">
                    <ContainerTable :data="boletines.data" :responsive="esMovil">
                        <b-table
                            hover
                            :items="boletines.data"
                            :fields="fields"
                            :busy="loading"
                        >
                            <template #cell(estado)="{ item }">
                                <b-alert
                                    show
                                    :variant="item.estado === 'Enviado' ? 'success' : 'danger'"
                                    class="p-1 mb-0"
                                    style="width: 110px; margin-left: auto; margin-right: auto"
                                >
                                    <template v-if="item.estado === 'Enviado'">
                                        <i class="fas fa-check-circle mr-1"></i>
                                        Enviado
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-times-circle text-warning mr-1"></i>
                                        No enviado
                                    </template>
                                </b-alert>
                            </template>
                            <template #cell(opciones)="{ item }">
                                <OpcionesDropdownTableComponent
                                    :options="[
                                        { to: { name: 'back.emails.boletines.show', params: { id: item.id }}, label: 'Ver boletín' },
                                        { to: { name: 'back.emails.boletines.editar', params: { boletin_id: item.id }}, label: 'Editar' },
                                        item.estado !== 'Enviado' ? { 
                                            to: { name: 'back.emails.boletines.enviar', params: { boletin_id: item.id } }, 
                                            label: 'Enviar' 
                                        } : [],
                                        { type: 'action', action: () => $modal.show('duplicar-boletin-' + item.id), label: 'Duplicar'},
                                        { type: 'action', action: () => $modal.show('borrar-boletin-' + item.id), label: 'Borrar boletín' }
                                    ]"
                                />
                                <BorrarModalComponent
                                    :name="'borrar-boletin-' + item.id"
                                    :title="'Borrar boletín: ' + item.asunto"
                                    :borrarTitle="
                                        '¿Está seguro que desea borrar el boletín: ' +
                                            item.asunto +
                                            '?'
                                    "
                                    confirmButton="Borrar boletín"
                                    @close="() => $modal.hide('borrarboletin-' + item.id)"
                                    @confirm="() => borrarBoletin(item.id)"
                                />

                                <ModalComponent
                                    :name="'duplicar-boletin-' + item.id"
                                    :title="'Duplicar boletín: ' + item.asunto"
                                    @close="() => $modal.hide('duplicar-boletin-' + item.id)"
                                >
                                    <div class="row">
                                        <div class="col-12 text-center mb-3">
                                            <h3>¿Está seguro que desea duplicar el boletín: {{ item.asunto }}?</h3>
                                        </div>
                                        <div class="col-12 text-center">
                                            <Button 
                                                type="button" 
                                                class="btn btn-primary mr-2" 
                                                @click="duplicarBoletin(item.id)"
                                                :disabled="loading"
                                            >
                                                Duplicar boletín
                                            </Button>
                                        </div>
                                    </div>
                                </ModalComponent>
                            </template>
                        </b-table>
                    </ContainerTable>
                </b-col>

                <b-col cols="12" md="4" lg="2" class="mt-3 mt-md-0">
                    <ListadoCarpetas 
                        ref="listadoCarpetas"
                        :carpetas="carpetas"
                        :loading.sync="loading"
                        :nombre="nombreCarpetas" 
                        :totalItems="'total_comunicados'" 
                        @filterCarpeta="(carpeta_id) => { filtersBoletines.carpeta_comunicado = carpeta_id }" 
                        @getItems="getBoletines"
                        @createCarpeta="createCarpeta"
                        @editCarpeta="editCarpeta"
                        @deleteCarpeta="deleteCarpeta"
                        @getCarpetas="getCarpetas"
                    />
                </b-col>
            </b-row>
        </template>
    </MainContentSearchable>

</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import apiService from '@/services/api-comunicados';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import ListadoCarpetas from '@/components/backend/campana-emails/boletines/ListadoCarpetas';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';
    import _ from 'lodash';
    import ModalComponent from '@/components/backend/components/ModalComponent.vue';

    export default {
        data() {
            return {
                loading: false,
                fields: [
                    { key: "asunto", label: "Asunto" },
                    { key: "fecha_ultimo_envio", label: "Fecha de último envío", class: "text-center" },
                    { key: "tipo", label: "Tipo", class: "text-center" },
                    { key: "estado", label: "Estado", class: "text-center" },
                    { key: "opciones", label: "Opciones", class: "text-center" }
                ],
                filtersBoletines: {
                    search:'',
                    carpeta_comunicado: null,
                    per_page: 10,
                    page: 1
                },
                filterscarpetasBoletines: {
                    search: '',
                    per_page: 10,
                },
                nombreCarpetas: 'Todos los Boletines',
                boletines: {
                    data: [],
                    meta: { current_page: 1, per_page: 10 }
                },
                carpetas: {
                    data: [],
                    meta: { current_page: 1, per_page: 10 },
                }
            }
        },
        created() {
            this.getBoletines();
            this.debouncedGetBoletines = _.debounce(this.getBoletines, 500);
            this.getCarpetas();
        },
        methods: {
            async getBoletines(resetCategory = false) {
                if (resetCategory) {
                    this.filtersBoletines.carpeta_comunicado = null;
                }
                this.loading = true;
                try {
                    this.boletines = await apiService.getBoletines(this.filtersBoletines);
                } catch (error) {
                    this.$toast.error("Error al obtener boletines");
                } finally {
                    this.loading = false;
                }
            },
            async borrarBoletin(id) {
                this.loading = true;

                try {
                    await apiService.borrarBoletin(id);
                    this.getBoletines();
                    this.$refs.listadoCarpetas.getCarpetas();
                } catch (error) {
                    this.$toast.error('Error al borrar el boletín', error);
                } finally {
                    this.$modal.hide('borrar-boletin-' + id);
                    this.loading = false;
                }
            },

            async duplicarBoletin(id){
                this.loading = true;

                try {
                    await apiService.duplicarBoletin(id);
                    this.$toast.success("Boletín duplicado correctamente");
                    
                    this.getBoletines();
                } catch (error) {
                    this.$toast.error("Error al duplicar el boletín");
                }finally{
                    this.$modal.hide('duplicar-boletin-' + id);
                    this.loading = false;
                }
            },

            async getCarpetas(textoFiltro) {
                this.$emit('update:loading', true);
                if(textoFiltro != null){
                    this.filterscarpetasBoletines.search = textoFiltro
                }
                try {
                    const response = await apiService.getCarpetasBoletines(this.filterscarpetasBoletines);
                    this.carpetas = {
                        ...response,
                        data: response.data.map(carpeta => ({
                            ...carpeta,
                            showIcons: false
                        }))
                    };
                } catch (error) {
                    this.$toast.error('Error al obtener las carpetas', error);
                } finally {
                    this.$emit('update:loading', false);
                }
            },
            async createCarpeta(data) {
                try {
                    this.$emit("update:loading", true);

                    await apiService.createCarpetasBoletines({
                        nombre: data.nombre,
                        descripcion: data.descripcion,
                    });

                    this.$toast.success("Carpeta creada correctamente");
                    this.$modal.hide("crear-carpeta");
                    this.getCarpetas();
                } catch (error) {
                    this.$toast.error("Hubo un error al crear la carpeta");
                } finally {
                    this.$emit("update:loading", false);
                }
            },
            async editCarpeta(data) {
                try {
                    await apiService.updateCarpetasBoletines(data);
                    this.$toast.success("Carpeta actualizada correctamente");
                    this.$modal.hide("editar-carpeta");
                    this.getCarpetas();
                } catch (error) {
                    this.$toast.error("Error al actualizar la carpeta");
                }
            },
            async deleteCarpeta(data) {
                try {
                    this.$emit("update:loading", true);
                    await apiService.deleteCarpetasBoletines(data.id);
                    this.$toast.success("Carpeta eliminada correctamente");
                    this.getCarpetas();
                } catch (error) {
                    this.$toast.error("Hubo un error al eliminar la carpeta");
                } finally {
                    this.carpetaAEliminar = null;
                    this.$modal.hide("eliminar-carpeta");
                    this.$emit("update:loading", false);
                }
            },

        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        watch: {
            'filtersBoletines.carpeta_comunicado'(newVal) {
                if (newVal !== null) {
                    this.getBoletines();
                }
            }
        },
        components: {
            MainContentSearchable, ListadoCarpetas, ContainerTable, OpcionesDropdownTableComponent, BorrarModalComponent, ModalComponent
        }
    }
</script>